[
  {
    "src": "images/somos1.png",
    "titulo": "Equipo Punta Alta Comunicación",
    "archivo": "<img src=\"images/02_Teambuilding.jpg\" class=\"img-fluid mx-auto\">",
    "texto": "¡Un teambuilding de película! <br>\n<span class=\"small\">Quedó demostrado que la actuación no es nuestro punto fuerte.</span>"
  },
  {
    "src": "images/somos2.png",
    "titulo": "Carlos, senior medical writer",
    "archivo": "<video controls style=\"width: 100%; height: auto\" id=\"videoModal\" preload class=\"mx-auto\">\n<source src=\"images/12_Llums-SantPau.mp4\" type=\"video/webm\" />\n</video>",
    "texto": "L’Univers de la llum’, la experiencia inmersiva de luces de Navidad en el Hospital de Sant Pau<br>\n<span class=\"small\">Los payasos de @Pallapupas y el periodista Jordi Basté encendieron las luces, y nosotros no podíamos perdérnoslo.</span>"
  },
  {
    "src": "images/somos3.png",
    "titulo": "Lorem Ipsum 1",
    "archivo": "<img src=\"images/03_Teambuilding.jpg\" class=\"img-fluid mx-auto\">",
    "texto": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis odio euismod libero imperdiet, eu porttitor sapien scelerisque."
  },
  {
    "src": "images/somos4.png",
    "titulo": "Lorem Ipsum 2",
    "archivo": "<img src=\"images/04_Teambuilding.jpg\" class=\"img-fluid mx-auto\">",
    "texto": "Donec accumsan ante ut diam maximus volutpat. Nullam eleifend odio nisi, vel dictum urna sollicitudin in."
  },
  {
    "src": "images/somos5.png",
    "titulo": "Lorem Ipsum 3",
    "archivo": "<img src=\"images/05_Teambuilding.jpg\" class=\"img-fluid mx-auto\">",
    "texto": "Fusce pellentesque, ex at facilisis euismod, lectus risus convallis ex, ut feugiat ante turpis non lacus."
  }
]
